import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { BaseHttpService } from 'src/app/service/base-http.service';

@Component({
	selector: 'app-sys-role-list',
	templateUrl: './sys-role-list.component.html',
	styleUrls: ['./sys-role-list.component.css']
})
export class SysRoleListComponent implements OnInit {
	error=null
	loading = false
	hasEditPerm = false;
	sysRoleList = null
	sysRolePagination = {
		currentPage: 1,
		pageSize: 10,
		pageCount: 0,
		rowCount: 0,
		pageList: null
	}
	searchForm: FormGroup = this.formBuilder.group({
		codeLike: ['', [Validators.maxLength(200)]],
		nameLike: ['', [Validators.maxLength(200)]],
		status: [null]
	});
	roleStatusOptionList = [
		{ value: null, label: "Tất cả" },
		{ value: 0, label: "Ngừng sử dụng" },
		{ value: 1, label: "Sử dụng" }
	]
	roleStatusOptionMap = {}
	constructor(private authService: AuthService,
		private formBuilder: FormBuilder,
		private httpService: BaseHttpService,
		private route: ActivatedRoute,
		private router: Router) { }
	ngOnInit(): void {
		this.authService.hasAnyPerm(['SYS_ROLE']).subscribe(hasPerm => {
			this.hasEditPerm = hasPerm;
		})
		for (var roleStatusOption of this.roleStatusOptionList) {
			this.roleStatusOptionMap[roleStatusOption.value] = roleStatusOption.label;
		}
		this.searchRole();
	}

	sysRolePageChange(page) {
		if(this.loading){
			return;
		}
		this.error = null;
		var searchFormData = this.searchForm.getRawValue()
		var findRequest: any = {}
		var codeLike = searchFormData["codeLike"];
		if (codeLike) {
			findRequest.codeLike = `%${codeLike}%`;
		}
		var nameLike = searchFormData["nameLike"];
		if (nameLike) {
			findRequest.nameLike = `%${nameLike}%`;
		}
		var status = searchFormData["status"];
		if (status !== null) {
			findRequest.status = status;
		}
		if (page < 1) {
			page = 1
		}
		findRequest.queryOffset = (page - 1) * this.sysRolePagination.pageSize;
		findRequest.queryLimit = this.sysRolePagination.pageSize;
		this.loading=true;
		this.httpService.post<any>(`/api/admin/sys/role/search`, findRequest).subscribe(findOtpRoleResponse => {
			this.loading=false;
			var rowCount = findOtpRoleResponse.rowCount;
			var pageCount = Math.ceil(rowCount / this.sysRolePagination.pageSize);
			var pageList = []
			for (var i = page - 2; i <= page + 2; i++) {
				if (i >= 1 && i <= pageCount) {
					pageList.push(i);
				}
			}
			this.sysRolePagination.currentPage = page;
			this.sysRolePagination.rowCount = rowCount;
			this.sysRolePagination.pageCount = pageCount;
			this.sysRolePagination.pageList = pageList;
			this.sysRoleList = findOtpRoleResponse.resultList;
		}, errorResponse => {
			this.loading=false;
			if(errorResponse.status==403){
			  this.router.navigate(['/login', { action: 'sessionExpired' }], { relativeTo: this.route });
			  return;
			}
			if (errorResponse.status > 0) {
				if (errorResponse.error?.errorCode) {
					this.error = errorResponse.error.errorCode + (errorResponse.error.errorMessage ? ":" + errorResponse.error.errorMessage : "");
					return;
				}
				this.error = errorResponse.status + ":" + errorResponse.error.error + (errorResponse.error.message ? ":" + errorResponse.error.message : "");
				return;
			}
			this.error = "Lỗi kết nối! Vui lòng thử lại sau";
		});
	}
	searchRole() {
		this.sysRolePageChange(1);
	}
	viewRole(sysRole) {
		this.router.navigate(['view', sysRole.id], { relativeTo: this.route })
	}
	insertRole() {
		this.router.navigate(['create'], { relativeTo: this.route })
	}
	editRole(sysRole) {
		this.router.navigate(['edit', sysRole.id], { relativeTo: this.route })
	}
	deleteRole(sysRole) {
		this.router.navigate(['delete', sysRole.id], { relativeTo: this.route })
	}
}


